import { useLocalStorage } from "@jti/ui/hooks/useStorage";

type FlotiqConfig = {
  flotiqApiKey: string;
  contentType: string;
};

export const FLOTIQ_CONFIG_STORAGE_KEY = "flotiqConfig";

export const useFlotiqStorageConfig = () => {
  const { getStorage, setStorage } = useLocalStorage();

  const flotiqConfig = getStorage(FLOTIQ_CONFIG_STORAGE_KEY, null) as FlotiqConfig | null;
  const setFlotiqConfig = (config: FlotiqConfig) => {
    setStorage(FLOTIQ_CONFIG_STORAGE_KEY, config);
  };

  return { flotiqConfig, setFlotiqConfig };
};
